import getMaxFavoriteSuggestionCounts from './getMaxFavoriteSuggestionCounts';
import FavoriteSuggestion from '../../types/FavoriteSuggestion';
import FavoriteSuggestionType from '../../types/FavoriteSuggestionType';
import { isGroupInFavorites } from 'owa-favorites';
import { getGroupsStore } from 'owa-groups-shared-store';
import { getLeftNavGroupsStore } from 'owa-group-left-nav';
import UnifiedGroupBase from 'owa-service/lib/contract/UnifiedGroupBase';

export default function getFavoriteGroupSuggestions(searchTerm: string): FavoriteSuggestion[] {
    const groupsStore = getGroupsStore();
    const leftNavGroupsStore = getLeftNavGroupsStore();
    const lowerCaseSearchTerm = searchTerm.toLocaleLowerCase();

    // First lets build an array with the Group Information for all the non favorite Groups. This array
    // will be sorted in prankie order because that is the order of myOrgGroups.
    let favoriteGroupsSuggestion = leftNavGroupsStore.myOrgGroups
        .filter(groupId => {
            return !isGroupInFavorites(groupId);
        })
        .map(groupId => {
            return groupsStore.groups.get(groupId).basicInformation;
        });

    // If a search term was provided, lets reduce the suggestions to only those containing the search term.
    // When no search term is provided, we will show the Groups in prankie order.
    if (searchTerm != '') {
        favoriteGroupsSuggestion = favoriteGroupsSuggestion.filter(group => {
            return (
                group.DisplayName.toLowerCase().indexOf(lowerCaseSearchTerm) >= 0 ||
                group.SmtpAddress.toLowerCase().indexOf(lowerCaseSearchTerm) >= 0
            );
        });

        sortByDisplayNamePrefixMatch(favoriteGroupsSuggestion, lowerCaseSearchTerm);
    }

    // Now lets reduce the result set to the maximum allowed for Groups
    favoriteGroupsSuggestion.splice(getMaxFavoriteSuggestionCounts().group);

    return favoriteGroupsSuggestion.map(group => {
        return {
            data: group.DisplayName,
            id: group.SmtpAddress,
            type: FavoriteSuggestionType.Group,
            relevance: 0,
        };
    });
}

function sortByDisplayNamePrefixMatch(array: Array<UnifiedGroupBase>, searchTerm: string) {
    array.sort((group1: UnifiedGroupBase, group2: UnifiedGroupBase) => {
        const group1DisplayName = group1.DisplayName.toLowerCase();
        const group2DisplayName = group2.DisplayName.toLowerCase();
        const group1DisplayNamePrefixMatch = group1DisplayName.indexOf(searchTerm) == 0;
        const group2DisplayNamePrefixMatch = group2DisplayName.indexOf(searchTerm) == 0;

        // Sort array so that Groups with Display Name prefix match show up first
        if (group1DisplayNamePrefixMatch && !group2DisplayNamePrefixMatch) {
            return -1;
        } else if (!group1DisplayNamePrefixMatch && group2DisplayNamePrefixMatch) {
            return 1;
        } else {
            // If we don't have a prefix match for the display name, we will keep the results sorted by prankie order
            return 0;
        }
    });
}
